(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["column-text-video"] && !Shopify.designMode) return;
  try {
    
  if(window.innerWidth > 1023) {
    let text_column_height = document.querySelector('.column-text').clientHeight;
    let video_column = document.querySelector('.column-video');
    if(text_column_height) {
      video_column.style.height = text_column_height+'px';
    }
  }

  } catch(e) { console.error(e); }
})();
})();
